import { createContext, useContext, useState, useCallback } from 'react';
import translations from '../i18n/translations';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('li-lang') || 'de');

  const switchLang = useCallback((newLang) => {
    setLang(newLang);
    localStorage.setItem('li-lang', newLang);
  }, []);

  const t = useCallback((key) => {
    return translations[lang]?.[key] || translations['de']?.[key] || key;
  }, [lang]);

  const getLocalizedField = useCallback((obj, field) => {
    if (!obj) return '';
    if (lang === 'de') return obj[field] || '';
    const localizedKey = `${field}_${lang}`;
    return obj[localizedKey] || obj[field] || '';
  }, [lang]);

  const getLocalizedObj = useCallback((obj) => {
    if (!obj) return '';
    return obj[lang] || obj['de'] || '';
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, switchLang, t, getLocalizedField, getLocalizedObj }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
